/**
 * Выбор темы в standalone. В embed тему задаёт платформа (`HostContext.theme`), и
 * переключателя там нет вовсе — поэтому переключатель приходит контекстом, который
 * существует только в standalone-дереве (`App.tsx`), а не флагом «мы не в embed».
 *
 * Выбор — удобство конкретного зрителя: localStorage, а недоступное хранилище
 * означает светлую тему по умолчанию.
 */

import { createContext, useContext } from 'react';
import { STANDALONE_THEME_MODE, type ThemeMode } from './appTheme';

const STORAGE_KEY = 'idea-calc-theme';

export function readStandaloneTheme(): ThemeMode {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : STANDALONE_THEME_MODE;
  } catch {
    return STANDALONE_THEME_MODE;
  }
}

export function writeStandaloneTheme(mode: ThemeMode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Тема просто не запомнится до следующего открытия.
  }
}

/** Переключить тему; `null` — переключать нечего (embed: тема платформы). */
export const ThemeToggleContext = createContext<(() => void) | null>(null);

export function useThemeToggle(): (() => void) | null {
  return useContext(ThemeToggleContext);
}
